import { Flex, Icon } from '@customerio/pluma-components/react';
import * as styles from './styles.css';

export function FlowIndicator() {
  return (
    <Flex alignItems="center" className={styles.arrowIcon} data-test-flow-indicator>
      <Icon name="no-change" size="sm" color="subtle" />
    </Flex>
  );
}
